import React from 'react';
import { Checkbox } from 'antd';

/**
 * Multi-select group driven by fieldRules.options.
 */
const CheckboxGroupField = ({
  options = [],
  value = [],
  onChange,
  disabled = false,
  showScoring = false,
}) => {
  const selected = Array.isArray(value) ? value : [];

  const toggle = (optionId) => {
    const next = selected.includes(optionId)
      ? selected.filter((entry) => entry !== optionId)
      : [...selected, optionId];
    onChange?.(next);
  };

  return (
    <div className="checkbox-group-field">
      {options.map((option) => {
        const checked = selected.includes(option.id);

        return (
          <div className="checkbox-group-field__row" key={option.id}>
            {showScoring && (
              // Ticked counts green, unticked counts red -- the same rule
              // DocumentRatingProcessor applies when it scores the checklist.
              <span
                className={`checkbox-group-field__dot checkbox-group-field__dot--${checked ? 'green' : 'red'}`}
                aria-hidden="true"
              />
            )}
            <Checkbox checked={checked} onChange={() => toggle(option.id)} disabled={disabled}>
              {option.label}
            </Checkbox>
          </div>
        );
      })}
    </div>
  );
};

export default CheckboxGroupField;
